<div class="process-card">

    <div class="card-header text-center">
        <img src="/assets/icons/avyna/logo.svg" alt="Avyna" class="brand-logo mb-3" />
    </div>

    <div class="content-area">
        <div class="error-view animate-fade-in">
            <mat-icon class="error-icon">gpp_bad</mat-icon>
            <h2 class="error-title">{{ 'app.auth.impersonation_expired.title' | translate }}</h2>
            <p class="error-desc">{{ 'app.auth.impersonation_expired.message' | translate: messageParams() }}</p>

            <div class="actions-area mt-4">
                <button mat-flat-button class="action-btn" (click)="returnToLogin()">
                    {{ 'app.auth.impersonation_expired.back_to_login' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <mat-icon class="secure-icon">lock</mat-icon>
        <span>{{ 'app.auth.callback.footer' | translate }}</span>
    </div>
</div>
